import { gql } from "@apollo/client";

export default gql`
  query getAllWorkers(
    $first: Int
    $last: Int
    $after: String
    $before: String
    $employerId: String!
    $vaccinationStatus: VaccinationStatus
    $order: [WorkerOrderInput!]
    $like: [WorkerFilterInput!]
  ) {
    workers(
      first: $first
      last: $last
      after: $after
      before: $before
      positionCountByEmployer: $employerId
      like: $like
      order: $order
      isActive: true
      isApproved: true
      isDeleted: false
      vaccinationStatus: $vaccinationStatus
    ) {
      totalCount
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          positionCountByEmployer(employerId: $employerId)
          fullName
          firstName
          lastName
          email
          phone
          profileImageUrl
          signedProfileImageUrl
          vaccinationStatus
          fullName
          rating
          city
          region
          positionCount
          banCount
          noShowCount
          isSuspended
        }
      }
    }
  }
`;
